import { ShareObjectStatus } from 'types/Share';

export const getTagColor = (type: ShareObjectStatus) => {
    switch (type) {
        case ShareObjectStatus.Approved:
            return 'success';
        case ShareObjectStatus.Rejected:
            return 'alert';
        case ShareObjectStatus.PendingApproval:
            return 'warning';
        case ShareObjectStatus.Draft:
            return 'warning';
        case ShareObjectStatus.Draft_Remove:
            return 'alert';
        case ShareObjectStatus.Shared:
            return 'success';
        case ShareObjectStatus.Removing:
            return 'alert';
        default:
            return 'info';
    }
};
